module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/puba.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("What Are the Akashic Records?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("T")]), _vm._v("he word "), _c('em', [_vm._v("Akasha")]), _vm._v(" is a Sanskrit word that means, variously, “primordial substance,” “ether,” “sky” or “cosmos.” The Akashic Records hold the records of all circumstances and actions concerning consciousness in all realities. They hold the story of your soul’s evolution from its inception up until the present time. They are the sum of all knowledge, past and present, and they contain the possibility of the unfolding of all future events (based on the choices that we make). The Akashic Records are essentially a compendium of all knowledge of the human experience encoded and stored in a non-physical (i.e., spiritual) plane of existence called "), _c('em', [_vm._v("Akasha")]), _vm._v(". I like to think of them as the Library of Congress of the soul. They are the recordings of your progression of lives, inscribed in your own personal Book of Life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every experience, thought, and emotion of every living thing, human and animal, is kept in this cosmic library. Every life form both contributes to and has access to the Records. Some philosophers, psychics, mystics, and spiritual practitioners believe that the events recorded upon Akasha can be accessed in only certain states of consciousness. Some people claim they can access the Akashic Records through dreams, trance, meditation, "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("or near-death experiences, but these methods are usually hit or miss. American mystic and psychic Edgar Cayce is an example of someone who claimed he had successfully read and used the Akashic Records. It is true that various techniques and spiritual disciplines, such as yoga, pranayama, meditation, prayer, and visualization, can be employed to quiet the mind and achieve the focused preconscious state necessary to access the Records. This can also be done if one has the right psychic abilities (as Edgar Cayce did). For our purposes, however, we will use the Sacred Prayer given to us by the Mayans. As we will see, it is not enough to simply read the prayer. We must prepare carefully and keep an open heart in order to connect to the Records and receive the information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Akasha has formed a part of many ancient belief systems. Numerous ancient cultures and socio-religious groups talked openly about the Akashic Records and claimed to have accessed them, including east Indians, Moors, Tibetans, Bonpos, Egyptians, Persians, Chaldeans, Greeks, Chinese, Hebrews, Christians, Druids, and Mayans. Sacred texts and manuscripts tell us that the ancient Indian sages of the Himalayas knew that each soul, or "), _c('em', [_vm._v("atman")]), _vm._v(", recorded every moment of its existence in a book, and that if one attuned oneself properly, one could access that book. In India today you can see Nadi palm leaf readers. The belief is that Lord Shiva imprints recordings of the Akashic Records onto palm leaves, and that each human has a leaf on which the recordings of his or her soul path and progression are inscribed. Perhaps the Nadi leaves are a physical aspect of the Akashic Records. In Hindu mysticism, Akasha is the actual substance on which events are recorded. It is also what the basic elements of nature—earth, fire, water, and air—are made of, the membrane that envelops everything in the universe, and the substance that holds everything together in the essence of love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nostradamus claimed to have gained access to Akasha using methods derived variously from the Greek oracles, Christianity, Sufi mysticism, and the Kabbalah. Other historical personages who claimed to have consciously used the Akashic Records include Alice Bailey, William Lilly, Manly P. Hall, Rudolf Steiner, and, of course, Edgar Cayce. Many students of metaphysics believe that the Vedas, the oldest scriptures of Hinduism, and Sanskrit, one of the oldest languages, were extracted directly from Akasha. According to acient Egyptian texts and scrolls, those who could read the Akashic Records in Egypt were held in high regard and would advise the Pharaohs on their daily activities and dream interpretation. The high priests and priestesses from the Mayan tradition imparted the Akashic Records to the people to help them bring their energy and knowledge to a much higher realm. As previously mentioned, it is through the Mayan tradition that we have received the Sacred Prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('em', [_vm._v("The Urantia Book")]), _vm._v(", a compendium of spiritual and philosophical writings by the Masters and angelic beings, confirms the validity and reality of the Akashic Records in several parts of the texts. Indeed, Paper 25 states, “The recording angels of the inhabited planets are the source of all individual records.” The Urantia Book discusses God, Jesus, science, cosmology, and religion, and is said to be a book of destiny. It was first discovered around 1924 and its main objective appears to be to reveal higher truths and thereby expand the consciousness of the reader.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Alternative names for the Akashic Records include:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Book of Life (Christian—Philippians 4:3, Malachi 3:16, Revelation 3:5, 3:8, 3:17, 8:20–21, 8:27)—“In the last days these books shall be opened.”")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Cosmic/Collective Consciousness")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Cosmic Mind")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Universal Mind")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Nature’s Memory")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Universal Library")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Book of Remembrance (Jewish)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Hall of Learning")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Hall of Knowledge")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Repository of Thoth (Egyptian)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Der Bewusstseinsraum")]), _vm._v(" (German; roughly translates as “the room of conscious knowledge of yourself”)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Akashic Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" Etheric Records (Tibetan)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/leaf.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Anima Mundi")]), _vm._v(" (“soul of the world”)")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Many people have a linear way of thinking about the Akashic Records. They visualize them as existing in a grand library or an etheric temple, a place where records and scrolls are kept. In a way this is correct, but they are much more than that. Looking at Diagram 1 on "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#page_28"
    }
  }, [_vm._v("page 28")]), _vm._v(" you can see the word "), _c('em', [_vm._v("Akasha")]), _vm._v(" on the far right with an arrow pointing up and down. This represents how Akasha is everywhere, the connective tissue that holds the universe together, much like the connective tissue in our own bodies. This connective tissue can be found in the tiniest of cells as well as the largest bones and organs; without it, our bodies would simply collapse. In the same way, Akasha is the connective tissue that holds the entire universe together, continuing into infinity. The most "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("beautiful part about this is that the purest essence of Akasha is love. This means that if we learn to truly speak the language of love, we can impact not only our world but the entire universe! With the energy that flows out of our hearts from a healed space, we can give our beauty and magnificence to all worlds in the pure essence of love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The triangle in the diagram represents the five planes of consciousness: the physical, astral, causal, mental, and etheric planes. We will explore each of these planes in greater depth further on in the book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Learning how to access your Akashic Records will give you the opportunity to use the Records’ energy and information on a personal basis. You will be able to ask general questions for problem-solving or for furthering your personal and spiritual growth. The healing energy of the Akashic Records allows us the freedom to choose grace in all things, overriding any illusion we have created that causes us to believe we are separated from Spirit. The material contained here comes from an ancient school of knowledge that will never bore you. As you enter into this mystery school and begin to study, recognize its potential and value in furthering your spiritual growth. You will be given information on ever-deepening levels, based on your openness and willingness as well as the relationship you develop with the Masters, the Record Keepers. Always act from your highest level of honesty and integrity. As you explore relationships and more, always ask for the highest good of everyone concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('strong', [_vm._v("Diagram 1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("The Akashic Records are one of the most powerful tools available on the planet today to help us remember our oneness with God and our own beauty and magnificence. One very important point to remember is that this process does not supersede any other spiritual work you are currently involved in, but rather will enhance it. Learning this material is working with the light for the highest good and looking to Spirit in a simple way for guidance, direction, and information. Your openness will determine both what you learn and how you use it."), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0